const defaultStaticData = {
  endpoints: {
    allotments: {
      url: '',
      headers: {
        'Ocp-Apim-Subscription-Key': '',
        Authorization: '',
      },
    },
    flight: {
      url: '',
      headers: {
        'Ocp-Apim-Subscription-Key': '',
        Authorization: '',
      },
    },
    jwt: {
      expiration: 0,
    },
    ssrs: {
      url: '',
      headers: {
        apiKey: '',
      },
    },
    ssrsTranslations: {
      url: '',
    },
  },
  msalConfig: {
    clientId: '',
    tenantId: ''
  },
  basePath: '/',
  changelog: {
    title: '',
    content: '',
  },
  lang: 'nl',
  splashScreenUrl: 'https://partner.transavia.com/nl/-/media/Images/Public/Backgrounds/paris-spring.jpg',
  logoUrl: 'https://partner.transavia.com/static/img/logos/transavia-logo-stacked-white.svg',
  labels: {},
  ecommerceDomainName: '',
  adminRole: '',
  applicationInsightsKey: undefined,
}
const staticData = {
  ...defaultStaticData,
  ...window.staticData,
  endpoints: window.staticData
    ? { ...defaultStaticData.endpoints, ...window.staticData.endpoints }
    : { ...defaultStaticData.endpoints },
}

export default staticData
